import { Injectable } from '@angular/core';
import {
  addWithRounding,
  calculateDepositAmountAndPercentage,
  checkTaxAccumulations,
  getValidAccumulations,
  percentageWithRounding,
  round,
  updateTaxRates,
} from 'i2g-yakka';
import { fromJS, List, Map } from 'immutable';
import { Document } from '../../../document-data/document.model';
import { CalculationResult } from '../../../document-data/sub-models/calculation-result.model';
import { DepositPayment } from '../../../document-data/sub-models/deposit-payment.model';
import { Deposit } from '../../../document-data/sub-models/deposit.model';
import { ErrorService } from '../../../error-reporting/error.service';
import { Tax } from '../../../settings-data/sub-models/company-settings/tax.model';
import { UtilsService } from '../utils/utils.service';

@Injectable()
export class CalculatorService {
  constructor(
    private _utilsService: UtilsService,
    private _errorService: ErrorService
  ) {}

  getCalculations(document: Document): Map<string, any> {
    try {
      return fromJS(this._utilsService.updateDocumentStates(document));
    } catch (error) {
      console.error(
        'calculation error with object',
        document.toJS(),
        'error:',
        error
      );

      this._errorService.alertSystem(error);

      return document as Map<string, any>;
    }
  }

  getValidAccumulations(taxes: List<Tax>, taxId: string): string[] {
    return getValidAccumulations(taxes.toJS(), taxId);
  }

  checkTaxAccumulations(taxes: List<Tax>, checkTax: Tax): boolean {
    return checkTaxAccumulations(taxes.toJS(), checkTax.toJS());
  }

  addWithRounding(a: number, b: number): number {
    return addWithRounding(a, b);
  }

  percentageWithRounding(base: number, percentage: number): number {
    return percentageWithRounding(base, percentage);
  }

  round(number: number): number {
    return round(number);
  }

  calculateDepositAmountAndPercentage(
    deposit: Deposit,
    calculationResult: CalculationResult
  ): DepositPayment {
    return new DepositPayment(
      calculateDepositAmountAndPercentage(
        deposit.toJS(),
        calculationResult.totalPayable
      )
    );
  }

  updateTaxRates(
    document: Document,
    taxId: string,
    newRates: number[]
  ): Map<string, any> {
    try {
      return fromJS(updateTaxRates(document.toJS(), taxId, newRates));
    } catch (error) {
      console.error(
        'update tax rates error with object',
        document.toJS(),
        'error:',
        error
      );

      this._errorService.alertSystem(error);

      return document as Map<string, any>;
    }
  }
}
